import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import QCNoneditable from '../SpreadSheet/QCNoneditable';
import { useLocation, useNavigate } from 'react-router-dom';
import jwt_decode from "jwt-decode";
import { baseUrl } from "../Services/Constants";
import { SimpleSnackbar } from '../Components/SnackBar';
import { GetQCJobDataByJobId } from "../Services/PreviewChecklistDataService";
import { GetLobDetailsForQuoteCompare } from '../Services/QuoteCompareService';

function CsrQuoteCompareWrapper() {
    const container = useRef();
    const location = useLocation();
    const navigate = useNavigate();
    const [isValidUser, setIsValidUser] = useState(null);
    const [sheetData, setSheetData] = useState(null);
    const [lobDetails, setLobDetails] = useState(null);

    useEffect(() => {
        sessionStorage.removeItem("lob");
        const checkAuthToken = async () => {
            let url = new URL(window.location.href);
            let urlParamToken = url?.searchParams.get("token");
            let jobId = url?.searchParams.get("jobId") || url?.searchParams.get("jobid");
            const lobRes = await GetLobDetailsForQuoteCompare(jobId.slice(0, 4), jobId);
            const lobList = [...new Set(lobRes?.map(e => e.LOB))];
            setLobDetails(lobList[0])

            if (urlParamToken && urlParamToken.length > 15 && (location.pathname.toLowerCase() === "/csrquotecompare")) {
                try {
                    let urlParamToken = url?.searchParams.get("token");
                    const decode_UserName = jwt_decode(urlParamToken || "");
                    const csrAuthQcUserName = decode_UserName?.preferred_username;

                    if (jobId && csrAuthQcUserName) {
                        sessionStorage.setItem("csrAuthQcUserName", csrAuthQcUserName);

                        const dataForcsrValidata = {
                            JobId: jobId,
                            csrName: csrAuthQcUserName,
                            token: urlParamToken
                        }

                        const response = await axios.post(
                            `${baseUrl}/api/Authentication/csrQcValidate`, dataForcsrValidata, {
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            }
                        }
                        );

                        if (response?.data?.IsValidUser === true) {
                            setIsValidUser(true);
                            container?.current?.showSnackbar("Authorized User", "success", true);

                            const sheetRes = await GetQCJobDataByJobId(jobId);
                            setSheetData(sheetRes);
                        } else {
                            container?.current?.showSnackbar(`${response?.data?.Message}`, "error", true);
                            setTimeout(() => {
                                navigate("/UnAuthorizedUser");
                            }, 1500);
                        }
                    }
                } catch (error) {
                    return error;
                } finally {
                    document.body.classList.remove('loading-indicator');
                    return "success";
                }
            }
        }

        checkAuthToken();
    }, [location]);

    if (isValidUser === null) return null;

    return (
        <>
            {isValidUser && location.pathname.toLowerCase() === "/csrquotecompare" && (
                <QCNoneditable
                    sheetData={sheetData}
                    lob={lobDetails}
                />
            )}
            <SimpleSnackbar ref={container} />
        </>
    );
}

export default CsrQuoteCompareWrapper;